import api from '@/services/api'
import api2 from '@/services/api2'


export default {
  namespaced: true,
  state: {
    accessToken: null,
    refreshToken: null,
    user: null,
  },
  mutations: {
    SET_ACCESS_TOKEN(state, token) {
      state.accessToken = token
    },
    SET_REFRESH_TOKEN(state, token) {
      state.refreshToken = token
    },
    SET_USER(state, user) {
      state.user = user
    },
    CLEAR_AUTH(state) {
      state.accessToken = null
      state.refreshToken = null
      state.user = null
    },
  },
  actions: {
    async login({ commit }, { username, password }) {
      try {
        const response = await api.post('/api/auth/login', { username, password })
       // const response = await api.post('/auth/login', config.headers['Content-type'] = 'application/x-www-form-urlencoded', { username, password })

        commit('SET_ACCESS_TOKEN', response.data.access_token)
        commit('SET_REFRESH_TOKEN', response.data.refresh_token)
       // commit('SET_USER', username) /// LVZ added
        console.log('Response data after login',response.data)
     //   console.log('user  data after vuex',username)
        return response.data
       
      } catch (error) {
        console.error('Login failed:', error)
        throw error
      }
    },
    async register({ commit }, { name, email, password, firstname, lastname, company, countryname, countrycode, status, okcomm  }) {
      try {
        const response = await api2.post('/api/register', { name, email, password, firstname, lastname, company, countryname, countrycode, status, okcomm })
        console.log('Response data after register',response.data)
        return response.data
      } catch (error) {
        console.error('Registration failed:', error)
        throw error
      }
    },
    async fetchUser({ commit }) {
      try {
        const response = await api.get('/api/users/me')
        commit('SET_USER', response.data)
        console.log('Response data after fetchUser',response.data)
        return response.data
      } catch (error) {
        console.error('Fetching user failed:', error)
        throw error
      }
    },


    async fetchAllUser({ commit }) {
      try {
        const response = await api.get('/api/admin/users/all')
        //commit('SET_USER', response.data)
        console.log('Response data after fetchAllUser', response.data)
        return response.data
      } catch (error) {
        console.error('Fetching user failed:', error)
        throw error
      }
    },

    async fetchUserID({ commit }, id) {
      try {
        const response = await api.get(`/api/admin/users/${id}`)
        return response.data
      } catch (error) {
        console.error('Fetching user failed:', error)
        throw error
      }
    },

    async saveUserProfile({ commit }, { id, editedValue }) {
      try {
        const response = await api2.post(`/api/admin/users/${id}`, { editedValue })
        return response.data
      } catch (error) {
        console.error('Saving user failed:', error)
        throw error
      }
    },

    async refreshToken({ commit, state }) {
      try {
        const response = await api.post('/api/auth/refresh', null, {
          headers: { 'Refresh-Token': state.refreshToken },
        })
        commit('SET_ACCESS_TOKEN', response.data.access_token)
        commit('SET_REFRESH_TOKEN', response.data.refresh_token)
        return response.data
      } catch (error) {
        console.error('Token refresh failed:', error)
        throw error
      }
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    },

    async activate({ commit }, { token, email }) {
      try {
        const response = await api2.post('/api/users/verify', { token, email })
        
        console.log('Active account',response.data)
        return response.data
       
      } catch (error) {
        console.error('Login failed:', error)
        throw error
      }
    },

/* 
    async fetchAccounts({ commit }) {
      try {
        const response = await api.get('/api/accounts')
        //commit('SET_USER', response.data)
        console.log('Response data after fetchAccounts', response.data)
        return response.data
      } catch (error) {
        console.error('Fetching accounts failed:', error)
        throw error
      }
    },
 */


  },
  getters: {
    //  This getter checks if the user is authenticated 
    // by evaluating the accessToken in the state.
    isAuthenticated: (state) => !!state.accessToken, //The !! operator converts the value of state.accessToken into a boolean. If accessToken is truthy (i.e., it exists and is not null or undefined),
    isAdmin: (state) => state.user && state.user.status === 'admin',
    
   //This getter simply returns the user object from the state.
    user: (state) => state.user,
  },
}